/**
 * @param {number} a 
 * @param {number} b 
 * @param {number} p 
 * @returns {number}
 */
export const calcBetween = (a, b, p) => a + (b - a) * p
